import { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router';
import { Amplify } from 'aws-amplify';

import { apiFetch } from '../../utils/Api';

export const AUTH_CHANNEL_NAME = 'altvia-sso-channel';
export const SSO_POPUP_FLAG = 'altvia-sso-popup';

const buildOauthConfig = (authConfig) => {
	const cleanDomain = authConfig?.oauth?.domain
		.replace('https://', '')
		.replace('http://', '');

	if (!cleanDomain) return {};

	return {
		...authConfig.oauth,
		domain: cleanDomain,
	};
};

export const createAuthLoader = async ({ request }) => {
	const url = new URL(request.url);
	const sfUserId =
		url.searchParams.get('id') || sessionStorage.getItem('sfUserId');

	if (!sfUserId) return null;

	try {
		const response = await apiFetch({
			endpoint: '/auth/aime_config',
			method: 'GET',
			params: { id: sfUserId },
		});

		sessionStorage.setItem('sfUserId', sfUserId);
		return { ...response.config, sfUserId };
	} catch (error) {
		console.warn('Unable to get auth config:', error);
		return null;
	}
};

export const useAuthConfig = () => {
	const authConfig = useLoaderData();
	const [ready, setReady] = useState(false);

	useEffect(() => {
		if (!authConfig) {
			setReady(true);
			return;
		}

		Amplify.configure({
			Auth: {
				Cognito: {
					userPoolId: authConfig.userPoolId,
					userPoolClientId: authConfig.clientId,
					loginWith: {
						oauth: buildOauthConfig(authConfig),
					},
				},
			},
		});

		setReady(true);
	}, [authConfig]);

	return { authConfig, ready };
};
